import {ColumnDataType, Resource} from "../../shared/model/resource";

export const alternativasResource: Resource = {
    nomeEntidade: {
        singular: 'Alternativa',
        plural: 'Alternativas'
    },
    fieldPk: 'uuid',
    route: {
        url: 'alternativas',
    },
    colunas: [
        {
            field: 'descricao',
            label: 'Descrição',
            required: true,
            sizeColumn: 'col-12',
            type: ColumnDataType.TextArea,
            textareaConfiguration: {
                rows: 6
            }
        },
        {
            field: 'pontuacao',
            label: 'Pontuação',
            sizeColumn: 'col-12',
            type: ColumnDataType.Number,
            numberConfiguration: {
                minValue: 0,
                maxValue: 10
            },
        }
    ],
    actions: [],
    availableReferences: []
}
